module.exports = __webpack_public_path__ + "static/futurist-0d4430ecda415769e1e7989ab0182344.ttf";